export const CARET_SIZE = 24;
//# sourceMappingURL=constants.js.map
// @zapier/universal-layout@8.6.23 (c29ded5a6)
